import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { UpcomingLaunchesResponse } from '@/types/launches';
import dayjs from 'dayjs';
import weekday from 'dayjs/plugin/weekday';

dayjs.extend(weekday);

const BASE_API_URL = 'https://ll.thespacedevs.com/2.3.0/launches/upcoming/';

const fetchUpcomingLaunches = async (
  startDate: string,
  endDate: string
): Promise<UpcomingLaunchesResponse> => {
  const params = new URLSearchParams({
    limit: '5',
    net__gte: startDate,
    net__lt: endDate,
  });

  const response = await axios.get(`${BASE_API_URL}?${params.toString()}`, {
    withCredentials: false,
  });
  return response.data;
};

const useQueryUpcomingLaunches = (
  startDate: dayjs.Dayjs,
  endDate?: dayjs.Dayjs
) => {
  const finalEndDate = endDate || startDate.add(7, 'days');

  const formattedStartDate = startDate.format('YYYY-MM-DDTHH:mm:ss[Z]');
  const formattedEndDate = finalEndDate.format('YYYY-MM-DDTHH:mm:ss[Z]');

  const weekKey = startDate.startOf('week').format('YYYY-MM-DD');

  return useQuery<UpcomingLaunchesResponse, Error>({
    queryKey: ['upcoming-launches', weekKey],
    queryFn: () => fetchUpcomingLaunches(formattedStartDate, formattedEndDate),
    staleTime: 7 * 24 * 60 * 60 * 1000,
    gcTime: 7 * 24 * 60 * 60 * 1000,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};

export default useQueryUpcomingLaunches;
